import script from "./pregnancyMainPage.vue?vue&type=script&setup=true&lang=js"
export * from "./pregnancyMainPage.vue?vue&type=script&setup=true&lang=js"

import "./pregnancyMainPage.vue?vue&type=style&index=0&id=75e4886e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75e4886e"]])

export default __exports__